import Vue from 'vue';
import App from './App';
import router from './router';
//引用element_ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//请求工具
import Axios from 'axios';
import {getDateRequest} from './utils/api';
import {postRequest} from './utils/api';
import {getRequest} from './utils/api';
import {postParamDun} from './utils/api';
import {postfromRequest} from './utils/api';
import { encrypt } from './components/common/common';
import { decrypt } from './components/common/common';
import { Decrypt } from './components/common/common';

// Vue.prototype.$posh = 'http://192.168.0.122:8888/';
Vue.prototype.$posh = "https://ins.xinchacha.com/";

Vue.prototype.$axios = Axios;
Vue.prototype.getDateRequest = getDateRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.postParamDun = postParamDun;
Vue.prototype.postfromRequest = postfromRequest;

Vue.prototype.$decrypt = decrypt;
Vue.prototype.$Decrypt = Decrypt;
Vue.prototype.$encrypt = encrypt;
Vue.config.productionTip = false;
Vue.use(ElementUI, {
  size: 'small'
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js